import { render, staticRenderFns } from "./GeneralMessage.vue?vue&type=template&id=60bca01e&"
import script from "./GeneralMessage.vue?vue&type=script&lang=js&"
export * from "./GeneralMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60bca01e')) {
      api.createRecord('60bca01e', component.options)
    } else {
      api.reload('60bca01e', component.options)
    }
    module.hot.accept("./GeneralMessage.vue?vue&type=template&id=60bca01e&", function () {
      api.rerender('60bca01e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/GeneralMessage.vue"
export default component.exports